// src/config/sportsConfig.js
/**
 * Frontend sports configuration — reflects odds-api.io / DraftKings + Bet365 coverage.
 * CATEGORY_TO_CATS and CAT_TO_ICON retain GoalServe codes for when GoalServe odds are active.
 */

export const SPORTS_CONFIG = {
  // American Football
  'americanfootball_nfl':   { name: 'NFL',   icon: '🏈', color: 'bg-red-600',    popular: true  },
  'americanfootball_ufl':   { name: 'UFL',   icon: '🏈', color: 'bg-orange-600', popular: false },
  'americanfootball_ncaaf': { name: 'NCAAF', icon: '🏈', color: 'bg-yellow-700', popular: false },

  // Basketball
  'basketball_nba':        { name: 'NBA',        icon: '🏀', color: 'bg-orange-600', popular: true  },
  'basketball_wnba':       { name: 'WNBA',       icon: '🏀', color: 'bg-purple-600', popular: false },
  'basketball_euroleague': { name: 'Euroleague', icon: '🏀', color: 'bg-blue-700',   popular: false },
  'basketball_eurocup':    { name: 'EuroCup',    icon: '🏀', color: 'bg-blue-600',   popular: false },
  'basketball_acb':        { name: 'ACB',        icon: '🏀', color: 'bg-red-600',    popular: false },
  'basketball_nbl':        { name: 'NBL',        icon: '🏀', color: 'bg-green-700',  popular: false },
  'basketball_ncaab':      { name: 'NCAAB',      icon: '🏀', color: 'bg-blue-800',   popular: false },
  'basketball_ncaaw':      { name: 'NCAAW',      icon: '🏀', color: 'bg-pink-600',   popular: false },

  // Baseball
  'baseball_mlb':  { name: 'MLB',            icon: '⚾', color: 'bg-green-600',  popular: true  },
  'baseball_npb':  { name: 'NPB',            icon: '⚾', color: 'bg-red-700',    popular: false },
  'baseball_kbo':  { name: 'KBO',            icon: '⚾', color: 'bg-blue-700',   popular: false },
  'baseball_cpbl': { name: 'CPBL',           icon: '⚾', color: 'bg-yellow-600', popular: false },
  'baseball_ncaa': { name: 'College Baseball',icon: '⚾', color: 'bg-orange-700', popular: false },

  // Ice Hockey
  'icehockey_nhl':          { name: 'NHL',           icon: '🏒', color: 'bg-blue-600',   popular: true  },
  'icehockey_del':          { name: 'DEL',           icon: '🏒', color: 'bg-gray-700',   popular: false },
  'icehockey_shl':          { name: 'SHL',           icon: '🏒', color: 'bg-yellow-700', popular: false },
  'icehockey_pwhl':         { name: 'PWHL',          icon: '🏒', color: 'bg-purple-600', popular: false },
  'icehockey_ligue_magnus': { name: 'Ligue Magnus',  icon: '🏒', color: 'bg-blue-800',   popular: false },
  'icehockey_khl':          { name: 'KHL',           icon: '🏒', color: 'bg-red-700',    popular: false },
  'icehockey_ahl':          { name: 'AHL',           icon: '🏒', color: 'bg-orange-600', popular: false },
  'icehockey_liiga':        { name: 'Liiga',         icon: '🏒', color: 'bg-indigo-700', popular: false },
  'icehockey_extraliga':    { name: 'Extraliga',     icon: '🏒', color: 'bg-red-800',    popular: false },
  'icehockey_nl':           { name: 'National Lg',    icon: '🏒', color: 'bg-gray-600',   popular: false },
  'icehockey_ncaa':         { name: 'NCAA Hockey',    icon: '🏒', color: 'bg-yellow-800', popular: false },

  // Soccer
  'soccer_epl':                   { name: 'EPL',          icon: '⚽', color: 'bg-purple-700', popular: true  },
  'soccer_spain_la_liga':         { name: 'La Liga',      icon: '⚽', color: 'bg-red-600',    popular: true  },
  'soccer_germany_bundesliga':    { name: 'Bundesliga',   icon: '⚽', color: 'bg-red-700',    popular: true  },
  'soccer_italy_serie_a':         { name: 'Serie A',      icon: '⚽', color: 'bg-blue-700',   popular: true  },
  'soccer_france_ligue_one':      { name: 'Ligue 1',      icon: '⚽', color: 'bg-blue-800',   popular: true  },
  'soccer_uefa_champs_league':    { name: 'UCL',          icon: '⚽', color: 'bg-indigo-700', popular: true  },
  'soccer_uefa_europa_league':    { name: 'UEL',          icon: '⚽', color: 'bg-orange-700', popular: false },
  'soccer_uefa_conference_league':{ name: 'UECL',         icon: '⚽', color: 'bg-green-600',  popular: false },
  'soccer_usa_mls':               { name: 'MLS',          icon: '⚽', color: 'bg-green-700',  popular: false },
  'soccer_netherlands':           { name: 'Eredivisie',   icon: '⚽', color: 'bg-orange-600', popular: false },
  'soccer_portugal':              { name: 'Primeira Liga', icon: '⚽', color: 'bg-green-700',  popular: false },
  'soccer_scotland':              { name: 'Scottish Prem',   icon: '⚽', color: 'bg-blue-700',    popular: false },
  // Soccer Tier 2
  'soccer_england_championship':  { name: 'Championship',    icon: '⚽', color: 'bg-purple-600',  popular: false },
  'soccer_germany_2_bundesliga':  { name: '2. Bundesliga',   icon: '⚽', color: 'bg-red-800',     popular: false },
  'soccer_spain_segunda':         { name: 'Segunda Division',icon: '⚽', color: 'bg-orange-700',  popular: false },
  'soccer_italy_serie_b':         { name: 'Serie B',         icon: '⚽', color: 'bg-blue-800',    popular: false },
  'soccer_france_ligue_2':        { name: 'Ligue 2',         icon: '⚽', color: 'bg-indigo-600',  popular: false },
  'soccer_belgium':               { name: 'Belgian Pro Lg',  icon: '⚽', color: 'bg-yellow-700',  popular: false },
  'soccer_turkey':                { name: 'Süper Lig',       icon: '⚽', color: 'bg-red-700',     popular: false },
  'soccer_brazil':                { name: 'Brasileirão',     icon: '⚽', color: 'bg-green-800',   popular: false },
  'soccer_argentina':             { name: 'Liga Profesional',icon: '⚽', color: 'bg-blue-600',    popular: false },
  'soccer_mexico':                { name: 'Liga MX',         icon: '⚽', color: 'bg-green-700',   popular: false },
  'soccer_saudi':                 { name: 'Saudi Pro Lg',    icon: '⚽', color: 'bg-green-600',   popular: false },
  'soccer_japan':                 { name: 'J-League',        icon: '⚽', color: 'bg-red-600',     popular: false },
  'soccer_australia':             { name: 'A-League',        icon: '⚽', color: 'bg-orange-600',  popular: false },

  // Tennis (all ATP + WTA tournaments combined)
  'tennis_atp_wta': { name: 'Tennis', icon: '🎾', color: 'bg-yellow-600', popular: true },

  // Combat Sports
  'boxing_boxing':          { name: 'Boxing',       icon: '🥊', color: 'bg-gray-700',   popular: false },
  'mma_mixed_martial_arts': { name: 'MMA',          icon: '🥊', color: 'bg-red-800',    popular: false },

  // Golf (all PGA / LIV tournaments)
  'golf_pga': { name: 'Golf', icon: '⛳', color: 'bg-green-800', popular: false },

  // Aussie Rules
  'aussierules_afl': { name: 'AFL', icon: '🏉', color: 'bg-yellow-700', popular: false },

  // Cricket
  'cricket_all': { name: 'Cricket', icon: '🏏', color: 'bg-green-700', popular: false },

  // Darts
  'darts_pdc': { name: 'Darts', icon: '🎯', color: 'bg-gray-600', popular: false },

  // Esports
  'esports_all': { name: 'Esports', icon: '🎮', color: 'bg-purple-800', popular: false },

  // Handball
  'handball_all': { name: 'Handball', icon: '🤾', color: 'bg-blue-700', popular: false },

  // Rugby
  'rugbyunion_all':  { name: 'Rugby Union',  icon: '🏉', color: 'bg-green-800', popular: false },
  'rugbyleague_all': { name: 'Rugby League', icon: '🏉', color: 'bg-red-700',   popular: false },

  // Table Tennis
  'tabletennis_all': { name: 'Table Tennis', icon: '🏓', color: 'bg-blue-600', popular: false },

  // Volleyball
  'volleyball_all': { name: 'Volleyball', icon: '🏐', color: 'bg-yellow-600', popular: false },
};

export const SPORT_CATEGORIES = {
  'American Football': ['americanfootball_nfl', 'americanfootball_ufl', 'americanfootball_ncaaf'],
  'Basketball':        ['basketball_nba', 'basketball_wnba', 'basketball_ncaab', 'basketball_ncaaw', 'basketball_euroleague', 'basketball_eurocup', 'basketball_acb', 'basketball_nbl'],
  'Baseball':          ['baseball_mlb', 'baseball_ncaa', 'baseball_npb', 'baseball_kbo', 'baseball_cpbl'],
  'Ice Hockey':        ['icehockey_nhl', 'icehockey_ahl', 'icehockey_ncaa', 'icehockey_del', 'icehockey_shl', 'icehockey_pwhl', 'icehockey_ligue_magnus', 'icehockey_khl', 'icehockey_liiga', 'icehockey_extraliga', 'icehockey_nl'],
  'Soccer': [
    // Tier 1
    'soccer_epl', 'soccer_spain_la_liga', 'soccer_germany_bundesliga',
    'soccer_italy_serie_a', 'soccer_france_ligue_one', 'soccer_uefa_champs_league',
    'soccer_uefa_europa_league', 'soccer_uefa_conference_league',
    'soccer_usa_mls', 'soccer_netherlands', 'soccer_portugal', 'soccer_scotland',
    // Tier 2
    'soccer_england_championship', 'soccer_germany_2_bundesliga', 'soccer_spain_segunda',
    'soccer_italy_serie_b', 'soccer_france_ligue_2', 'soccer_belgium', 'soccer_turkey',
    'soccer_brazil', 'soccer_argentina', 'soccer_mexico', 'soccer_saudi',
    'soccer_japan', 'soccer_australia',
  ],
  'Tennis':        ['tennis_atp_wta'],
  'Combat Sports': ['boxing_boxing', 'mma_mixed_martial_arts'],
  'Golf':          ['golf_pga'],
  'Aussie Rules':  ['aussierules_afl'],
  'Cricket':       ['cricket_all'],
  'Darts':         ['darts_pdc'],
  'Esports':       ['esports_all'],
  'Handball':      ['handball_all'],
  'Rugby':         ['rugbyunion_all', 'rugbyleague_all'],
  'Table Tennis':  ['tabletennis_all'],
  'Volleyball':    ['volleyball_all'],
};

export const POPULAR_SPORTS = Object.keys(SPORTS_CONFIG).filter(
  key => SPORTS_CONFIG[key].popular
);

export const getSportConfig = (sportKey) => {
  return SPORTS_CONFIG[sportKey] || {
    name: sportKey,
    icon: '🎯',
    color: 'bg-gray-600',
    popular: false
  };
};

export const getCategoryForSport = (sportKey) => {
  for (const [category, sports] of Object.entries(SPORT_CATEGORIES)) {
    if (sports.includes(sportKey)) {
      return category;
    }
  }
  return 'Other';
};

// Futures/Championship Markets Configuration
export const FUTURES_CONFIG = {
  // American Football
  'americanfootball_nfl_super_bowl_winner': {
    name: 'Super Bowl',
    displayName: 'Super Bowl Winner',
    icon: '🏈',
    color: 'bg-red-600',
    category: 'American Football',
    description: 'NFL Super Bowl Championship'
  },
  'americanfootball_ncaaf_championship_winner': {
    name: 'CFP Champion',
    displayName: 'College Football Champion',
    icon: '🏈',
    color: 'bg-orange-600',
    category: 'American Football',
    description: 'College Football Playoff Championship'
  },

  // Basketball
  'basketball_nba_championship_winner': {
    name: 'NBA Champion',
    displayName: 'NBA Championship',
    icon: '🏀',
    color: 'bg-orange-600',
    category: 'Basketball',
    description: 'NBA Championship Winner'
  },
  'basketball_ncaab_championship_winner': {
    name: 'March Madness',
    displayName: 'NCAA Tournament Winner',
    icon: '🏀',
    color: 'bg-blue-600',
    category: 'Basketball',
    description: 'March Madness Championship'
  },

  // Baseball
  'baseball_mlb_world_series_winner': {
    name: 'World Series',
    displayName: 'World Series Winner',
    icon: '⚾',
    color: 'bg-green-600',
    category: 'Baseball',
    description: 'MLB World Series Championship'
  },

  // Ice Hockey
  'icehockey_nhl_championship_winner': {
    name: 'Stanley Cup',
    displayName: 'Stanley Cup Winner',
    icon: '🏒',
    color: 'bg-blue-600',
    category: 'Ice Hockey',
    description: 'NHL Stanley Cup Championship'
  },

  // Golf
  'golf_masters_tournament_winner': {
    name: 'Masters',
    displayName: 'Masters Tournament Winner',
    icon: '⛳',
    color: 'bg-green-800',
    category: 'Golf',
    description: 'The Masters Tournament'
  },
  'golf_pga_championship_winner': {
    name: 'PGA Championship',
    displayName: 'PGA Championship Winner',
    icon: '⛳',
    color: 'bg-blue-800',
    category: 'Golf',
    description: 'PGA Championship'
  },
  'golf_the_open_championship_winner': {
    name: 'The Open',
    displayName: 'The Open Championship Winner',
    icon: '⛳',
    color: 'bg-yellow-700',
    category: 'Golf',
    description: 'The Open Championship (British Open)'
  },
  'golf_us_open_winner': {
    name: 'US Open Golf',
    displayName: 'US Open Winner',
    icon: '⛳',
    color: 'bg-indigo-800',
    category: 'Golf',
    description: 'US Open Golf Championship'
  },

  // Soccer
  'soccer_fifa_world_cup_winner': {
    name: 'World Cup',
    displayName: 'FIFA World Cup Winner',
    icon: '⚽',
    color: 'bg-yellow-500',
    category: 'Soccer',
    description: 'FIFA World Cup Championship'
  }
};

export const FUTURES_CATEGORIES = {
  'American Football': ['americanfootball_nfl_super_bowl_winner', 'americanfootball_ncaaf_championship_winner'],
  'Basketball': ['basketball_nba_championship_winner', 'basketball_ncaab_championship_winner'],
  'Baseball': ['baseball_mlb_world_series_winner'],
  'Ice Hockey': ['icehockey_nhl_championship_winner'],
  'Golf': ['golf_masters_tournament_winner', 'golf_pga_championship_winner', 'golf_the_open_championship_winner', 'golf_us_open_winner'],
  'Soccer': ['soccer_fifa_world_cup_winner']
};

export const getFuturesConfig = (futuresKey) => {
  return FUTURES_CONFIG[futuresKey] || {
    name: futuresKey,
    displayName: futuresKey,
    icon: '🏆',
    color: 'bg-gray-600',
    category: 'Other',
    description: ''
  };
};

// Sport keys that are always shown in the sub-tab nav regardless of active games
export const PERMANENT_SPORT_KEYS = new Set([
  // American Football
  'americanfootball_nfl', 'americanfootball_ufl', 'americanfootball_ncaaf',
  // Basketball
  'basketball_nba', 'basketball_wnba', 'basketball_ncaab', 'basketball_ncaaw', 'basketball_euroleague', 'basketball_eurocup', 'basketball_acb', 'basketball_nbl',
  // Baseball
  'baseball_mlb', 'baseball_ncaa', 'baseball_npb', 'baseball_kbo', 'baseball_cpbl',
  // Ice Hockey
  'icehockey_nhl', 'icehockey_ahl', 'icehockey_ncaa', 'icehockey_del', 'icehockey_shl', 'icehockey_pwhl', 'icehockey_ligue_magnus', 'icehockey_khl', 'icehockey_liiga', 'icehockey_extraliga', 'icehockey_nl',
  // Soccer
  'soccer_epl', 'soccer_spain_la_liga', 'soccer_germany_bundesliga',
  'soccer_italy_serie_a', 'soccer_france_ligue_one', 'soccer_uefa_champs_league',
  'soccer_uefa_europa_league', 'soccer_uefa_conference_league',
  'soccer_usa_mls', 'soccer_netherlands', 'soccer_portugal', 'soccer_scotland',
  'soccer_england_championship', 'soccer_germany_2_bundesliga', 'soccer_spain_segunda',
  'soccer_italy_serie_b', 'soccer_france_ligue_2', 'soccer_belgium', 'soccer_turkey',
  'soccer_brazil', 'soccer_argentina', 'soccer_mexico', 'soccer_saudi',
  'soccer_japan', 'soccer_australia',
  // Tennis
  'tennis_atp_wta',
  // Combat Sports
  'boxing_boxing', 'mma_mixed_martial_arts',
  // Golf
  'golf_pga',
  // Aussie Rules
  'aussierules_afl',
  // Cricket
  'cricket_all',
  // Darts
  'darts_pdc',
  // Esports
  'esports_all',
  // Handball
  'handball_all',
  // Rugby
  'rugbyunion_all', 'rugbyleague_all',
  // Table Tennis
  'tabletennis_all',
  // Volleyball
  'volleyball_all',
]);

// Maps GoalServe cat code to a display icon — used for dynamic league tabs
export const CAT_TO_ICON = {
  'basket_10':       '🏀',
  'hockey_10':       '🏒',
  'baseball_10':     '⚾',
  'football_10':     '🏈',
  'soccer_10':       '⚽',
  'tennis_10':       '🎾',
  'mma_10':          '🥊',
  'boxing_10':       '🥊',
  'rugby_10':        '🏉',
  'rugbyleague_10':  '🏉',
  'golf_10':         '⛳',
  'cricket_10':      '🏏',
  'handball_10':     '🤾',
  'volleyball_10':   '🏐',
  'esports_10':      '🎮',
  'table_tennis_10': '🏓',
  'darts_10':        '🎯',
  'futsal_10':       '⚽',
};

// Maps frontend category name to one or more GoalServe cat codes
// Used for the active-leagues fetch
export const CATEGORY_TO_CATS = {
  'American Football': ['football_10'],
  'Basketball':        ['basket_10'],
  'Baseball':          ['baseball_10'],
  'Ice Hockey':        ['hockey_10'],
  'Soccer':            ['soccer_10'],
  'Tennis':            ['tennis_10'],
  'Golf':              ['golf_10'],
  'Combat Sports':     ['mma_10', 'boxing_10'],
  'Rugby':             ['rugby_10', 'rugbyleague_10'],
  'Cricket':           ['cricket_10'],
  'Handball':          ['handball_10'],
  'Volleyball':        ['volleyball_10'],
  'Esports':           ['esports_10'],
  'Table Tennis':      ['table_tennis_10'],
  'Darts':             ['darts_10'],
  'Futsal':            ['futsal_10'],
};
